var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "id": "filterCardFilter"
    }
  }, [!_vm.hideDivider ? _c('v-divider') : _vm._e(), _c('v-card-title', {
    class: _vm.padding ? 'pb-1' : 'pa-0'
  }, [_vm.isSerachActivated ? _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": 12,
      "align": "center"
    }
  }, [_c('v-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.confirmSearch.apply(null, arguments);
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.isSearchLoading,
      "placeholder": _vm.$t('components.filter.label'),
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "data-test-search-field": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('clickSearch');
      },
      "click:clear": function clickClear($event) {
        _vm._search = '';
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function fn() {
        return [_vm.showAs === _vm.ShowAsOptionsEnum.MENU ? _c('filter-card-pagination-menu', {
          attrs: {
            "filterList": _vm.filterList,
            "large": _vm.large,
            "filter": _vm._filter,
            "predefinedFilter": _vm.predefinedFilter,
            "search": _vm.search
          },
          on: {
            "removeAll": function removeAll($event) {
              _vm.selectedQuickFilters = [];
            },
            "confirmFilter": _vm.confirmFilter
          }
        }) : _vm.showAs === _vm.ShowAsOptionsEnum.SIDE_CARD ? _c('div', {
          staticClass: "mr-2",
          staticStyle: {
            "margin-top": "-16px",
            "margin-left": "-10px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "data-test-filter": ""
          },
          on: {
            "click": _vm.toggleSideCard
          }
        }, [_c('v-icon', {
          attrs: {
            "color": _vm.filter.length ? 'info' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.filter.length ? "mdi-filter" : "mdi-filter-outline") + " ")])], 1), _c('v-divider', {
          staticStyle: {
            "position": "relative",
            "top": "10px",
            "left": "2px"
          },
          attrs: {
            "vertical": ""
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('tooltip', {
          attrs: {
            "text": "".concat(_vm.$t('components.filter.label'), ": ").concat(_vm.filterLabel)
          }
        }, [_c('v-icon', {
          attrs: {
            "data-test-search-button": ""
          },
          on: {
            "click": _vm.confirmSearch
          }
        }, [_vm._v(" mdi-magnify ")])], 1)];
      },
      proxy: true
    }], null, false, 2362021595),
    model: {
      value: _vm._search,
      callback: function callback($$v) {
        _vm._search = $$v;
      },
      expression: "_search"
    }
  })], 1)], 1) : _vm._e(), !_vm.isSerachActivated ? _c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('filter-card-pagination-menu', {
    attrs: {
      "showAs": _vm.showAs,
      "filterList": _vm.filterList,
      "large": _vm.large,
      "filter": _vm._filter,
      "predefinedFilter": _vm.predefinedFilter,
      "search": _vm.search
    },
    on: {
      "update:filter": function updateFilter($event) {
        _vm._filter = $event;
      },
      "confirmFilter": _vm.confirmFilter
    }
  })], 1) : _vm._e(), _vm.quickFilters.length ? _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-chip-group', {
    attrs: {
      "row": "",
      "multiple": "",
      "active-class": "primary--text text--accent-4"
    },
    model: {
      value: _vm.selectedQuickFilters,
      callback: function callback($$v) {
        _vm.selectedQuickFilters = $$v;
      },
      expression: "selectedQuickFilters"
    }
  }, _vm._l(_vm.quickFilters, function (filter) {
    return _c('v-chip', {
      key: 'quick-filter-' + filter.name,
      attrs: {
        "disabled": _vm.isSideCard,
        "label": "",
        "pill": "",
        "small": "",
        "outlined": "",
        "value": filter.filter
      },
      on: {
        "click": function click($event) {
          return _vm.onSelectedQuickFiltersChanged(filter.filter);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(filter.name)) + " ")]);
  }), 1), _vm.activeFiltersNotPartOfQuickFilters.length ? _c('v-chip-group', {
    attrs: {
      "value": [0],
      "active-class": "primary--text text--accent-4"
    }
  }, [_c('v-chip', {
    attrs: {
      "disabled": _vm.isSideCard,
      "color": "info",
      "label": "",
      "pill": "",
      "small": "",
      "outlined": "",
      "value": 0
    },
    on: {
      "click": _vm.toggleSideCard
    }
  }, [_vm.activeFiltersNotPartOfQuickFilters.length === 1 ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.additionalActiveFiltersSingular")) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.additionalActiveFiltersPlural", {
    count: _vm.activeFiltersNotPartOfQuickFilters.length
  })) + " ")])])], 1) : _vm._e()], 1), _c('debug', _vm._l(_vm._filter, function (filter, index) {
    return _c('v-chip', {
      key: "filters-filter-".concat(filter.key, "-").concat(filter.operation, "-").concat(filter.value, "-").concat(filter.type, "-").concat(index),
      attrs: {
        "disabled": _vm.isSideCard,
        "label": "",
        "pill": "",
        "small": "",
        "outlined": "",
        "close": ""
      },
      on: {
        "click:close": function clickClose() {
          _vm._filter.splice(index, 1);

          _vm.onConfirmFilter();
        }
      }
    }, [_vm._v(" " + _vm._s(filter.key) + " " + _vm._s(filter.operation) + " " + _vm._s(filter.value) + " (" + _vm._s(filter.type) + ") ")]);
  }), 1)], 1) : _vm._e()], 1), !_vm.hideDivider ? _c('v-divider') : _vm._e(), _vm.isSideCard ? _c('filter-card-pagination-side-card', {
    ref: "sideCard",
    attrs: {
      "filterList": _vm.filterList,
      "large": _vm.large,
      "filter": _vm._filter,
      "predefinedFilter": _vm.predefinedFilter,
      "quickFilters": _vm.quickFilters,
      "search": _vm.search
    },
    on: {
      "update:filter": function updateFilter($event) {
        _vm._filter = $event;
      },
      "confirmFilter": _vm.onConfirmFilter,
      "close": function close($event) {
        _vm.isSideCard = false;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }